<template>
  <div class="column-left-side">
    <div v-for="({ id, section, url, text, list, tags = [], subResults = [] }, index) in data"
         :key="index">

      <div v-if="section === 'regular_result'"
           :cy="`regular-result-${index + 1}`"
           class="regular-result">
        <div class="flex flex-between">
          <p class="">
          <span>
            {{ text }}
          </span>
            <br>
            <a :href="url"
               target="_blank">
              [{{ shortenUrl(url) }}]
            </a>
          </p>
          <TagsList :tags="tags"
                    :result-id="id"
                    :column-id="columnId"
                    @select="handleTagSelect" />
        </div>
        <ul v-if="subResults.length"
            class="sub-results m-l-16 m-t-8">
          <li v-for="(item, index) in subResults"
              :key="index"
              class="m-b-4">
            {{ item }}
          </li>
        </ul>
      </div>

      <div v-if="section === 'people_also_ask'">
        <ListCard title="People also ask"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.question"
                  :list="list" />
      </div>

      <div v-if="section === 'twitter_results'">
        <ListCard title="Twitter results"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.twitter"
                  :list="list" />
      </div>

      <div v-if="section === 'top_stories'"
           cy="books"
           class="flex flex-between">
        <ListCard title="Top stories"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.news"
                  :list="list" />
      </div>

      <div v-if="section === 'videos'"
           cy="books"
           class="flex flex-between">
        <ListCard title="Videos"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.videos"
                  :list="list" />
      </div>

      <div v-if="section === 'books'"
           cy="books"
           class="flex flex-between">
        <ListCard title="Books"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.books"
                  :list="list" />
      </div>

      <div v-if="section === 'people_also_search_for'">
        <ListCard title="People also search for"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.people"
                  :list="list" />
      </div>

      <div v-if="section === 'people_also_search_for_people'">
        <ListCard title="People also search for people"
                  :tags="tags"
                  :result-id="id"
                  :column-id="columnId"
                  :icon="icons.people"
                  :list="list" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import ListCard from "@/components/ListCard.vue";
  import TagsList from "@/components/TagsList.vue";
  import {icons} from "@/store/data";

  defineProps({
    data: Array,
    columnId: String
  })

  const { commit } = useStore()

  function shortenUrl (url = '') {
    const regex = /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/i;
    const match = url.match(regex);
    return match ? match[1] : '';
  }

  function handleTagSelect (payload) {
    commit('SET_TAG', payload)
  }
</script>

<style lang="scss">
  @import "../styles/vars";

  .column-left-side {
    @media only screen and (min-width: 0) {
      padding: 12px 4px 12px 24px;
      //max-width: 400px;
      .regular-result {
        margin-bottom: 12px;
        p {
          margin: 0 12px 0 0;
          span {
            margin-right: 24px;
          }
        }
      }
      h3 {
        display: flex;
        align-items: center;
        span {
          margin-left: 8px;
          font-size: 1.8rem;
          color: $black;
        }
      }
      .card-content {
        margin-top: 8px;
        padding: 8px 12px;
        background-color: #F8F7F7;
        border-radius: 8px;
      }
      .answer-list li {
        margin-bottom: 4px;
        font-size: 1.5rem;
        span {
          font-size: 1.5rem;
        }
      }
      .list-card {
        margin-bottom: 12px;
      }
    }
  }
</style>